"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleAction = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var SingleActionElements = _interopRequireWildcard(require("./Action.styles"));

var Elements = _interopRequireWildcard(require("../ActionModals/ActionModal.styles"));

var _Activity = require("./components/Activity");

var _ActionDetail = require("../ActionModals/ViewAction/components/ActionDetail");

var _LoadingOverlay = require("../ActionModals/components/LoadingOverlay");

var _context = require("../ActionModals/ViewAction/context");

var _utils = require("../ActionModals/ViewAction/utils");

var _actionField = require("../../context/actionField");

var _attachments = require("../../context/attachments");

var _eventTracking = require("../../utils/eventTracking");

const SingleAction = ({
  actionId,
  userDisplayName
}) => {
  const {
    action,
    actionStatus
  } = (0, _context.useState)();
  const {
    loadAction,
    setAction,
    loadMessages,
    loadMentionsList,
    setUserDisplayName
  } = (0, _context.useActions)();
  const actionLabel = `#${(0, _utils.stripProjectPrefix)(actionId)}`;
  React.useEffect(() => {
    void loadAction(actionId);
    setUserDisplayName(userDisplayName);
    (0, _eventTracking.viewedActionEvent)(actionId);
  }, []);
  const handleActionChange = React.useCallback(function handleActionChange(updated) {
    setAction(updated); // If status is being updated, refresh messages
    // to display the new status transition message.

    if (action !== undefined && action.bonfire_status !== updated.bonfire_status) {
      void loadMessages(action.key);
    }
  }, [action]);
  React.useEffect(() => {
    if (actionStatus === _context.Status.ready && action !== undefined) {
      void loadMentionsList(action.project_key, action.components);
    }
  }, [actionStatus]);
  return /*#__PURE__*/React.createElement(SingleActionElements.Frame, null, /*#__PURE__*/React.createElement(_blocks.Thirds, null, /*#__PURE__*/React.createElement(_blocks.Left, null, /*#__PURE__*/React.createElement(SingleActionElements.GoBack, {
    to: "/actions"
  }, /*#__PURE__*/React.createElement(_blocks.Back, {
    text: /*#__PURE__*/React.createElement(_react.Trans, {
      id: "single_action.back_link"
    })
  }))), /*#__PURE__*/React.createElement(_blocks.Center, null, /*#__PURE__*/React.createElement(Elements.Title, null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "view_action_modal.header_title",
    values: {
      actionLabel: actionLabel
    }
  }))), /*#__PURE__*/React.createElement(_blocks.Right, null)), /*#__PURE__*/React.createElement(SingleActionElements.Wrapper, null, /*#__PURE__*/React.createElement(Elements.Content, {
    style: {
      height: '100%'
    }
  }, actionStatus === _context.Status.loading && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, null), action !== undefined && actionStatus === _context.Status.ready && /*#__PURE__*/React.createElement(SingleActionElements.Column, null, /*#__PURE__*/React.createElement(_attachments.AttachmentsProvider, null, /*#__PURE__*/React.createElement(_actionField.ActionFieldProvider, null, /*#__PURE__*/React.createElement(_ActionDetail.ActionDetail, {
    withInModal: false,
    action: action,
    onActionChange: handleActionChange
  })))), /*#__PURE__*/React.createElement(SingleActionElements.ActivityColumn, null, /*#__PURE__*/React.createElement(_Activity.Activity, null)))));
};

exports.SingleAction = SingleAction;